export default __webpack_public_path__ + "static/media/userloginhistory.0f811ffa.svg";